<script>
import * as acessomodulo from '@/api/acessomodulo'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data () {
    return {
      title: 'Listar Acesso Módulo',
      modal: {
        component: 'app-acessomodulo-edit',
        width: 300,
        field: 'descricao'
      },
      backend: acessomodulo
    }
  }
}
</script>

<template>
  <simple-crud-grid :title="title" :mode="mode" :modal="modal" :backend="backend" @save="(data) => $emit('save', data)" />
</template>
